<div class="login-box">
  <div class="login-logo">
    <a [routerLink]="['/']"><b>bciti+</b>&nbsp;CERBERUS</a>
  </div>
  <!-- /.login-logo -->
  <div class="card">
    <div class="card-body login-card-body">
      <p class="login-box-msg">Sign in to start your session</p>

      <form [formGroup]="loginForm">
        <div class="input-group mb-3">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Environment</mat-label>
            <mat-select formControlName="env" (valueChange)="selectEnv($event)">
              <mat-option *ngFor="let env of environments" [value]="env">
                {{ env.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="input-group mb-3">
          <input
            formControlName="email"
            type="email"
            class="form-control"
            placeholder="Email"
          />
          <div class="input-group-append">
            <div class="input-group-text">
              <span class="fas fa-envelope"></span>
            </div>
          </div>
        </div>
        <div class="input-group mb-3">
          <input
            formControlName="password"
            type="password"
            class="form-control"
            placeholder="Password"
          />
          <div class="input-group-append">
            <div class="input-group-text">
              <span class="fas fa-lock"></span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-7">
            <div class="icheck-primary">
              <input type="checkbox" id="remember" />
              <label for="remember"> Remember Me </label>
            </div>
          </div>
          <!-- /.col -->
          <div class="col-5">
            <app-button
              [type]="'submit'"
              [block]="true"
              [text]="'Sign In'"
              [loading]="isAuthLoading"
              (click)="login()"
            ></app-button>
          </div>
          <!-- /.col -->
        </div>
      </form>
    </div>
    <!-- /.login-card-body -->
  </div>
</div>
